define('ch_footer',[
    'jquery',
    'jquery.validate.min',
    'ch_form_validation',
    'ch_modal_window',
    'ch_selectors',
    'ch_category_preferences',
    'ch_ga',
    'ch_load_mask',
], function ($) {
    var $emailCaptureInFooter;

    // @todo - multiple pages use this, we should move it into a global lib
    CH.thankYouSubmitEmail = function () {
        swal('Thank you', 'Check your email for exclusive offers!', 'success');
    };

    // newsletter email capture
    function initFooterEmailForm() {
        $emailCaptureInFooter = $._('form_CaptureEmail_footer');

        $emailCaptureInFooter.each(function () {
            CH.validate($(this), {
                submitHandler: function (form) {
                    $(form).find('input').blur();
                    $('body').maskElement('');
                    $.ajax({
                        type: 'POST',
                        url: form.action,
                        data: $(form).serialize(),
                        xhrFields: {
                            withCredentials: true,
                        },
                        success: function (res) {
                            $('body').unmaskElement('');
                            if (!res.success && res.error) {
                                new ModalMessage({ message: res.error });
                                return;
                            }

                            // Send GA Event
                            ga('send', 'event', 'Email Capture', 'Subscribe', $._('funnel').val());

                            $emailCaptureInFooter.each(function (index, form) {
                                $(form).get(0).reset();
                            });

                            if (CH.showCategoryPreferencesWindow() === false) {
                                CH.thankYouSubmitEmail();
                            };
                        },
                    });
                },
            });
        });
    }

    if (!CH.isMobile) {
        $(initFooterEmailForm);
    }
});

